import React from "react";
import styled from "styled-components";

const MainHolder = styled.div`
  height: 300px;
  position: relative;
  overflow: hidden;
  background-color: #f9f9f9;
`;

const Positioner = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
`;

const Element = styled.div`
  width: 100%;
  position: relative;
  background: url("/images/flower.svg") 70% 100% no-repeat;
  background-color: #f9f9f9;
`;

const Text = styled.div`
  font-family: "Basteleur";
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 125%;
  color: #e96159;
  position: absolute;
  left: 16px;
  right: 0px;
  bottom: 24px;
`;

const Subtitle = styled.div`
  border-top: 1px solid #e96159;
  border-bottom: 1px solid #e96159;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #e96159;
  background-color: #ffffff;
`;

const Holder = styled.div`
  max-width: 500px;
  width: 100%;
  padding: 16px;
  margin: 0 auto;
  position: relative;
  height: 200px;
`;

const Extra = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #737373;
  margin-bottom: 10px;
`;

export default function Display({ children, text, extra, total }) {
  return (
    <MainHolder>
      <Positioner>
        <Element>
          <Holder>
            <Text>
              <Extra>
                {extra}
                {total ? `: ${total}` : ""}
              </Extra>
              {text}
            </Text>
          </Holder>
        </Element>
        {children && (
          <Subtitle>
            <Holder style={{ height: "auto" }}>{children}</Holder>
          </Subtitle>
        )}
      </Positioner>
    </MainHolder>
  );
}
